/** @jsx builderX.jsx */

import {builderX, Sprite, Image, Text, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite position={[0, 0]} name='totalBet'>
        <Image name='bg' src='total_bet_bg' />
        <Button position={[650, 5]} hitArea={{ width: 100, x: 0, y: 0, type: 'rectangle', height: 130 }} name='plusButton'>
            <Sprite>
                <Image src='plus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_focused' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[5, 5]} hitArea={{ width: 100, x: 0, y: 0, type: 'rectangle', height: 130 }} name='minusButton'>
            <Sprite>
                <Image src='minus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_focused' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_disabled' />
            </Sprite>
        </Button>
        <Text
            position={[79, 3]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 80,
                fontStyle: 'normal',
                fill: '#FFFFFF',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={600}
            name='fieldText'
            localeTextID=''
            text='$0.50'
        />
        <Text
            position={[178, 87]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 40,
                fontStyle: 'normal',
                fill: '#FFD200',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={400}
            name='label'
            localeTextID=''
            text='TOTAL BET'
        />
    </Sprite>
);
